export default function energy (grains, fps) {
  const ftLbs = (fps ** 2 * grains) / 450240
  return ftLbs
}
